import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import { getInstituteMarker } from "../../services/PartnerServices";

const mapStyles = [
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{ "color": "#444444" }],
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{ "color": "#f2f2f2" }],
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{ "visibility": "off" }],
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{ "saturation": -100 }, { "lightness": 45 }],
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{ "visibility": "simplified" }],
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{ "visibility": "off" }],
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{ "visibility": "off" }],
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{ "color": "#46bcec" }, { "visibility": "on" }],
  },
];

const Map = () => {
  const [position, setPosition] = useState({
    lat: 20.5937,
    lng: 78.9629,
  });
  const [markers, setMarkers] = useState([]);
  const [activeMarker, setActiveMarker] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getInstituteMarker().then((res) => {
      setMarkers(res.data);
    });
  }, []);

  const handleActiveMarker = (markerId) => {
    if (markerId === activeMarker) {
      return;
    }
    setActiveMarker(markerId);
  };

  const handleOnLoad = (map) => {
    const bounds = {
      north: 37.6,
      south: 8.4,
      east: 97.4,
      west: 68.7,
    };

    const center = {
      lat: (bounds.south + bounds.north) / 2,
      lng: (bounds.west + bounds.east) / 2,
    };

    map.setCenter(center);
    map.setZoom(5);
  };

  const handleMarkerClick = (id) => {
    navigate(`/training-institute/${id}`);
  };

  if (window.google == undefined) return <div>Error loading maps</div>;

  return (
    <GoogleMap
      onLoad={handleOnLoad}
      onClick={() => setActiveMarker(null)}
      center={position}
      zoom={5}
      mapContainerStyle={{
        width: "100%",
        height: "400px", // Default height for desktop view
        // Inline CSS for responsive design
        maxWidth: "100%",
        maxHeight: "100%",
        '@media (max-width: 768px)': {
          height: "60vh", // Height for mobile view
        },
      }}
      options={{ styles: mapStyles }}
    >
      {markers?.map(({ _id, instituteName, location }) => (
        <Marker
          key={_id}
          position={{
            lat: location.coordinates[0],
            lng: location.coordinates[1],
          }}
          onClick={() => handleMarkerClick(_id)}
        />
      ))}

      {activeMarker !== null && (
        <InfoWindow
          position={{
            lat: markers.find((marker) => marker._id === activeMarker).location
              .coordinates[1],
            lng: markers.find((marker) => marker._id === activeMarker).location
              .coordinates[0],
          }}
          onCloseClick={() => setActiveMarker(null)}
        >
          <div>
            {
              markers.find((marker) => marker._id === activeMarker)
                .instituteName
            }
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default Map;
